module.exports = __webpack_public_path__ + "img/six_zhTc.bde3eccf.png";